import { SET_THEME } from './actionTypes';

export const setTheme = (darkmode) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('darkmode', darkmode.toString());
  }
  return {
    type: SET_THEME,
    payload: darkmode,
  };
};

export const setThemeOnLoad = () => {
  let darkmode = 'false';
  if (typeof window !== 'undefined') {
    darkmode = localStorage.getItem('darkmode');
  }
  if (darkmode == 'false') {
    return {
      type: SET_THEME,
      payload: false,
    };
  } else {
    return {
      type: SET_THEME,
      payload: true,
    };
  }
};
